module.exports = __webpack_public_path__ + "img/管理系统.041952a2.png";